export default __webpack_public_path__ + "static/media/IsabelLai.712483ae.JPG";